import { createApi } from '@reduxjs/toolkit/query/react'

import { transformResponse, baseQuery } from '../../helpers/rtk-query-tools';

export interface UpdateArgs {
  playerId: number
  channel: number
}

export type UpdateStationArgs = UpdateArgs & {
  stationId: number
}

export type UpdateVolumeArgs = UpdateArgs & {
  volume: number
}

export type TriggerJingleArgs = UpdateArgs & {
  jingleId: number
}

export const apiCube = createApi({
  reducerPath: 'apiCube',
  baseQuery,
  endpoints: builder => ({

    getStatus: builder.query<any, void>({
      query: () => 'cube_interface/get_cubes_status',
      transformResponse
    }),

    updateStation: builder.mutation<any, UpdateStationArgs>({
      query: args => `cube_interface/update_cube_station/?cubeId=${args.playerId}&output=${args.channel}&stationId=${args.stationId}`,
      transformResponse
    }),

    updateVolume: builder.mutation<any, UpdateVolumeArgs>({
      query: args => `cube_interface/update_cube_volume/?cubeId=${args.playerId}&output=${args.channel}&volume=${args.volume}`,
      transformResponse
    }),

    triggerJingle: builder.mutation<any, TriggerJingleArgs>({
      query: args => `cube_interface/trigger_jingle/${args.playerId}/${args.channel}/${args.jingleId}`,
      transformResponse
    })

  })
});

export const {
  endpoints: {
    getStatus,
    updateStation,
    updateVolume,
    triggerJingle
  },
  useGetStatusQuery
} = apiCube;
